import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import { formatDate } from '@angular/common';
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {HorasExtrasTurnosService} from "../../services/horas-extra-turnos.service";
import {Row, Workbook as wb, Worksheet} from 'exceljs';
import {saveAs} from 'file-saver';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-horas-extra-carga-turnos',
  templateUrl: './horas-extra-carga-turnos.component.html',
  styleUrls: ['./horas-extra-carga-turnos.component.css']
})
export class HorasExtraCargaTurnosComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbYears: any[] = [];
  cmbWeeks: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  @ViewChild('fileInput') fileInput: ElementRef;

  rrhh: boolean = false;
  cmbDepartment = [];


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private _horasExtrasTurnos: HorasExtrasTurnosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    route.data.subscribe((data) => {
      this.rrhh = data.rrhh;
    })
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasCargarTurno;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.formulario = this.fb.group({
      department: ['', this.rrhh ? [Validators.required] : []],
      year: [''],
      week: [''],
      startDate : ['', [Validators.required]],
      endDate   : ['', [Validators.required]],
    });
    this.uploadForm = this.fb.group({
      excel: [''],
    });
    if (this.rrhh) {
      this.loadDepartments();
    }
    this.girdComponent();
    this.selectCurrentDate();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }

  calculateWeeks(year, today?) {
    this.cmbWeeks = [];
    let firtsDateOfActualYear = new Date('01/01/' + year);
    let lastDateOfActualYear = new Date('12/31/' + year);
    for (let weeks = 1; firtsDateOfActualYear <= lastDateOfActualYear; weeks++) {
      let monday = this.getMondayOfCurrentWeek(firtsDateOfActualYear);
      let sunday = this.getSundayOfCurrentWeek(firtsDateOfActualYear);
      const payload = {
        id: weeks,
        descripcion: 'Semana ' + (weeks < 10 ? '0' + weeks : weeks) + ':   ' + this.formatoFecha(monday) + ' - ' + this.formatoFecha(sunday),
      };
      if (today && this.validateDate(firtsDateOfActualYear, today)) {
        this.actualWeek = weeks;
      }
      this.cmbWeeks.push(payload);
      firtsDateOfActualYear = this.addDays(firtsDateOfActualYear, 7);
    }
  }

  changeYear() {
    if (this.formulario.get('year').value) {
      this.calculateWeeks(this.formulario.get('year').value);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }

  calculateCombos() {
    const date = new Date();
    let year = date.getFullYear();
    this.calculateWeeks(year, date);
    this.cmbYears = [
      {
        id: year - 1,
        descripcion: year - 1
      },
      {
        id: year,
        descripcion: year
      },
      {
        id: year + 1,
        descripcion: year + 1
      }
    ];
  }

  selectCurrentDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.formulario.get('year').setValue(year);
    this.formulario.get('week').setValue(this.actualWeek);
    this.listAll();
  }

  getAllTurnos() {
    this.loading = true;
    const payload = this.formulario.value;
    this._horasExtrasTurnos.getAllRango(payload).subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'COLABORADOR',
        field: 'nombre',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 200
      },
      /*{
        headerName: 'DIA',
        field: 'dia',
        sortable: true,
        filter: true,
        width: 200
      },*/
      {
        headerName: 'HORA INICIO',
        field: 'horaInicio',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'HORA FIN',
        field: 'horaFin',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelection = 'single';
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  listAll() {
    if (this.formulario.valid) {
      this.getAllTurnos();
    }
  }

  descargarCsv() {
    this.generarEcxel();
  }


  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        dia: x.dia,
        horaInicio: x.horaInicio,
        horaFin: x.horaFin,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'carga_turnos' + '.xlsx');
    });
  }

  fillExcelMarketplace() {
    const nameSheet = 'Carga de turnos';
    let header;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Fecha',
      'Hora inicio',
      'Hora Fin',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 10;
    worksheet.columns[4].width = 10;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatData(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }


  onFileSelect(event) {
    if (event.target.files.length > 0) {
      this.loading = true;
      let allowedExtensions = /(.xlsx)$/i;
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.uploadForm.get('excel').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "xlsx" (EXCEL) ', true, 9000);
        this.fileInput.nativeElement.value = '';
        this.loading = false;
      } else {
        this.uploadForm.get('excel').setValue(file);
        const formData = new FormData();
        formData.append('file', this.uploadForm.get('excel').value);
        const payload = this.formulario.value;
        this._horasExtrasTurnos.loadShifts(payload, formData).subscribe(response => {
          this.listAll();
        }, (error) => {
          let errorMensaje = error.error.mensaje + '<br/>';
          let text = '';
          try {
            error.error.respuesta.forEach(errorObject => {
              text = text + '<br/>' + '<br/>' + errorObject;
            });
          } catch (e: any) {
            text = text + '<br/>' + '<br/>' + error.error.respuesta;
          }
          this._util.mensajeErrorVisto(errorMensaje, true, 90000, text);
          this.listAll();
        });
      }
    }
  }

  loadDepartments() {
    this._horasExtrasTurnos.getAllDepartment().subscribe((res) => this.cmbDepartment = res)
  }
}
